<div class="tw-mt-8 tw-flex tw-justify-between tw-items-center">
  <div>
    <button
      type="button"
      (click)="onBack()"
      class="tw-inline-flex tw-items-center tw-gap-1 tw-text-primary-700 hover:tw-text-primary-800 tw-text-sm tw-font-medium"
    >
      <da-icon icon="chevron-left" type="solid-small" />
      <span [textContent]="i18n.Core_Back"></span>
    </button>
  </div>
  <div class="tw-flex tw-gap-4">
    <button
      type="button"
      (click)="onCancel()"
      class="tw-btn-secondary-outline tw-btn-medium"
    >
      {{ i18n.Core_Cancel }}
    </button>
    <button
      type="button"
      (click)="!isSaving && onSave()"
      [attr.aria-disabled]="isSaving"
      [attr.aria-label]="isSaving ? i18n.Core_Loading : i18n.Core_Save"
      class="tw-btn-primary tw-btn-medium"
      [class.tw-opacity-60]="isSaving"
      [class.tw-cursor-not-allowed]="isSaving"
    >
      @if (isSaving) {
        <da-icon icon="arrow-path" type="solid-small" class="tw-animate-spin" />
      }
      {{ i18n.Core_Save }}
    </button>
  </div>
</div>
